import { render, staticRenderFns } from "./lateArrivalPenalty.vue?vue&type=template&id=120da58e&scoped=true&"
import script from "./lateArrivalPenalty.vue?vue&type=script&lang=js&"
export * from "./lateArrivalPenalty.vue?vue&type=script&lang=js&"
import style0 from "./lateArrivalPenalty.vue?vue&type=style&index=0&id=120da58e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120da58e",
  null
  
)

export default component.exports